import * as React from "react";
import { Component } from "react";
import { AuthManager } from "../../component/auth/AuthContext";
import LabelizeApi, { LabelPartParam, LabelWorkflowBatch } from "../../api/LabelizeApi";
import CancelableAxiosInstance from "../../api/CancelableAxiosInstance";
import "./labelize-part-param.scss";
import ArrayUtil from "../../util/ArrayUtil";
import LabelPartParamItem from "./LabelPartParamItem";
import { RouteComponentProps } from "react-router";
import i18n from "i18next";

interface LabelizePartParamProps extends RouteComponentProps {
  authManager: AuthManager;
}

interface LabelizePartParamState {
  lwb: LabelWorkflowBatch;
  partParams?: LabelPartParam[];

  prefValues?: string[];
  saving: boolean;
}

interface ValueCpt {
  value: string;
  cpt: number;
}

export default class LabelizePartParam extends Component<LabelizePartParamProps, LabelizePartParamState> {
  private labelizeApi: LabelizeApi;
  private client: CancelableAxiosInstance;
  private valueCptsByType: Map<string, ValueCpt[]> = new Map<string, ValueCpt[]>();

  constructor(props: LabelizePartParamProps) {
    super(props);
    this.labelizeApi = LabelizeApi.with(props.authManager.cancelableClient());
    this.client = props.authManager.cancelableClient();
    const params = new URLSearchParams(props.location.search);
    this.state = {
      saving: false,
      lwb: { labelBatchId: params.get("lbId"), labelWorkflowId: params.get("lwId") },
    };
  }

  componentDidMount(): void {
    this.startWorkflow();
  }

  componentWillUnmount(): void {
    this.client.cancelRequests();
  }

  private startWorkflow(): void {
    this.labelizeApi.queryPartParamsByWorkflow(this.state.lwb).then((partParams) => {
      if (partParams.length == 0) {
        this.props.history.push("/labelize");
      } else {
        partParams.forEach((pp) => {
          // force validated by default
          pp.imageState = "validated";
          pp.state = "validated";
        });
        this.setState({ partParams: partParams });
      }
    });
  }

  private onValueChange(pp: LabelPartParam) {
    let valueCpts = this.valueCptsByType.get(pp.type);

    if (!valueCpts) {
      this.valueCptsByType.set(pp.type, (valueCpts = []));
    }

    let valueCpt = ArrayUtil.findFirst(valueCpts, (elm) => elm.value === pp.value);

    if (!valueCpt) {
      valueCpts.push((valueCpt = { value: pp.value, cpt: 0 }));
    }

    valueCpt.cpt++;

    // resort values
    this.valueCptsByType.set(
      pp.type,
      valueCpts.sort((v1, v2) => {
        return v1.cpt >= v2.cpt ? -1 : 1;
      })
    );

    this.setState({ prefValues: this.getPrefValues(pp.type) });
  }

  private getPrefValues(type: string): string[] {
    const valueCpts = this.valueCptsByType.get(type);
    if (!valueCpts) return [];

    return valueCpts.slice(0, valueCpts.length > 3 ? 3 : valueCpts.length).map((v) => v.value);
  }

  private savePartParams() {
    this.setState({ saving: true });

    const functions = [] as any[];

    this.state.partParams.forEach((pp) => {
      functions.push(() => this.labelizeApi.savePartParam(pp));
    });

    functions
      .reduce((p, fn) => p.then(fn), Promise.resolve())
      .then(() => {
        this.setState({ saving: false });
        this.startWorkflow();
      });
  }

  render() {
    return (
      <>
        <div className="container-fluid">
          <div className="row">
            {this.state.partParams &&
              this.state.partParams.map((pp, idx) => {
                return (
                  <div
                    className="col-sm-3 label-part-param p-0"
                    key={pp.studyId + "-" + pp.imageId + "-" + pp.partIdx + "-" + idx}
                  >
                    <div className="card">
                      <div className="card-body">
                        <LabelPartParamItem
                          client={this.client}
                          partParam={pp}
                          onValueChange={(pp) => this.onValueChange(pp)}
                          prefValues={this.state.prefValues}
                          index={idx}
                          authManager={this.props.authManager}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>

          {this.state.partParams && this.state.partParams.length > 0 && (
            <div className="row mt-1">
              <button
                onClick={() => this.savePartParams()}
                disabled={this.state.saving}
                className="btn btn-primary btn-block"
              >
                {!this.state.saving && <span>{i18n.t("global.validate")}</span>}
                {this.state.saving && (
                  <span>
                    {" "}
                    {i18n.t("global.recording")} <i className="fa fa-spinner fa-spin" />
                  </span>
                )}
              </button>
            </div>
          )}
        </div>
      </>
    );
  }
}
